import ScheduleCard from "components/common/Card/ScheduleCard";
import Carousel from "components/common/Carousel";
import React from "react";
import styles from "./index.module.scss";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { t } from "i18next";

const DailySchedule = ({ calender }) => {
  const { dir } = useAppSelector(getSettings);

  const carouselOptions = {
    slidesPerView: 1,
    pagination: { clickable: true },
  };

  const renderItem = (item) => <ScheduleCard item={item} />;
  return (
    <div className={styles["schedule"]} dir={dir}>
      <div className={`${styles["schedule-top-wrapper"]} w-fit`} dir={dir}>
        <h2 className={`text-2xl font-medium text-white`}>
          {t("careerTabScheduleTitleText")}
        </h2>
      </div>
      <Carousel
        items={calender.days}
        renderItem={renderItem}
        options={carouselOptions}
        sliderDailyScheduleBtns={true}
        className={"w-full calender-carousel"}
      />
    </div>
  );
};

export default DailySchedule;
